import { useState, useEffect } from 'react';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import type { ActivityResourceType } from '@confluence/fabric-providers/entry-points/ActivityProvider.ts';
import { getActivityProvider } from '@confluence/fabric-providers/entry-points/ActivityProvider.ts';

export function useActivityProvider() {
	const [activityProvider, setActivityProvider] = useState<
		Promise<ActivityResourceType> | undefined
	>(undefined);
	const { cloudId } = useSessionData();

	useEffect(() => {
		setActivityProvider(getActivityProvider(cloudId));
	}, [cloudId]);

	return activityProvider;
}
